module.exports = __webpack_public_path__ + "static/headless-matt-9287c5f4a41677d969d1587e7873ca8b.jpg";